import {
  ACCOUNT_INFO_LOADED,
  PAGES,
  REDUCE_CREDIT_LIMIT_FAILED,
  REDUCE_CREDIT_LIMIT_SUCCEEDED,
  START_CLICKED,
} from "./constants";
import { Action, State } from "./types";

const emptyFormValues = {
  newCreditLimit: "",
};

const initialReduceCreditLimitState: State = {
  page: PAGES.LANDING,
  formValues: emptyFormValues,
};

function reduceCreditLimitReducer(state: State, action: Action): State {
  switch (state.page) {
    case PAGES.LANDING: {
      switch (action.type) {
        case ACCOUNT_INFO_LOADED: {
          return {
            ...state,
            page:
              action.accountInfo.creditLimit <=
              action.accountInfo.cardMinCreditLimit
                ? PAGES.ALREADY_AT_MINIMUM_CREDIT_LIMIT
                : action.accountInfo.currentBalance >
                  action.accountInfo.creditLimit
                ? PAGES.OVER_CREDIT_LIMIT
                : PAGES.CAN_REDUCE,
            accountInfo: action.accountInfo,
            formValues: state.formValues,
            postReduceCreditLimitHref: action.postReduceCreditLimitHref,
          };
        }
        default: {
          return state;
        }
      }
    }

    case PAGES.CAN_REDUCE: {
      switch (action.type) {
        case START_CLICKED: {
          return {
            ...state,
            page: PAGES.FORM,
          };
        }

        default: {
          return state;
        }
      }
    }

    case PAGES.FORM: {
      switch (action.type) {
        case REDUCE_CREDIT_LIMIT_SUCCEEDED: {
          return {
            ...state,
            page: PAGES.SUCCESS,
          };
        }

        case REDUCE_CREDIT_LIMIT_FAILED: {
          return {
            ...state,
            page: PAGES.ERROR,
            errorType: action.errorType,
          };
        }

        default: {
          return state;
        }
      }
    }

    default: {
      return state;
    }
  }
}

export { PAGES, initialReduceCreditLimitState, reduceCreditLimitReducer };
